<h2 mat-dialog-title>EDIT TEST LIMIT</h2>
<mat-dialog-content>
  @if(formTest){
    <form [formGroup]="formTest" (ngSubmit)="save()">
      <table>
        <tr>
          <td>
            <label>PROFILE:</label>
          </td>
          <td colspan="4" style="font-weight: bold; font-size: large;">
            {{this.data.ProfileName}}
          </td>
        </tr>
        <tr>
          <td>
            <label>TEST:</label>
          </td>
          <td colspan="4" style="font-weight: bold; font-size: large;">
            {{this.data.Test.Name}}
          </td>
        </tr>

      </table>
      <mat-divider></mat-divider>
      <br/>
      <table>
        <tr>
          <td colspan="2">
            <mat-slide-toggle
              color="primary"
              style="padding-left: 40px;"
              matInput
              formControlName="IncludeInTotalRanking"
              >
              Included in score
            </mat-slide-toggle>
          </td>
          <td></td>
          <td>
            <mat-form-field appearance="fill" class="smallfield">
              <mat-label>View order</mat-label>
              <input matInput placeholder="" formControlName="OrderInProfile" />
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td>Limits</td>
        </tr>
        <tr>
          <td style="text-align: right; white-space: nowrap;">

            <mat-form-field appearance="fill" class="smallfield">
              <mat-label>OK</mat-label>
              <input matInput placeholder="" formControlName="LimitOK" />
              @if (!limit.LimitMultiplierTestId) {
                <mat-hint>
                  {{ limit.ResultUnit }}
                </mat-hint>
              }
              <!--  <mat-hint
              style="white-space: nowrap;"
              *ngIf="limit.LimitMultiplierTestId"
              >
              <span style="font-size: medium; width: 50px;">*</span>
              <mat-icon style="font-size: small;">assignment_turned_in</mat-icon>
              <b>{{ limit.LimitMultiplierTestName }}</b>
            </mat-hint> -->
          </mat-form-field>
        </td>
        <td>
          <mat-form-field appearance="fill" class="smallfield">
            <mat-label>Good</mat-label>
            <input matInput placeholder="" formControlName="LimitGood" />
            @if (!limit.LimitMultiplierTestId) {
              <mat-hint>
                {{ limit.ResultUnit }}
              </mat-hint>
            }

          </mat-form-field>
        </td>
        <td>
          <mat-form-field appearance="fill" class="smallfield">
            <mat-label>Very Good</mat-label>
            <input matInput placeholder="" formControlName="LimitVeryGood" />
            @if (!limit.LimitMultiplierTestId) {
              <mat-hint>
                {{ limit.ResultUnit }}
              </mat-hint>
            }

          </mat-form-field>
        </td>
        <td>
          <mat-form-field appearance="fill" class="smallfield">
            <mat-label>Excellent</mat-label>
            <input matInput placeholder="" formControlName="LimitExcellent" />
            @if (!limit.LimitMultiplierTestId) {
              <mat-hint>
                {{ limit.ResultUnit }}
              </mat-hint>
            }

          </mat-form-field>
        </td>
      </tr>
    </table>
    <mat-divider></mat-divider>
    @if (this.DynamicLimitsEnabled==true){
    <label>DYNAMIC LIMITS</label>  
    <button mat-button type="button" (click)="showLimitGuide()" >
      <mat-icon>help_outline</mat-icon> 
    </button>
    <div style="display: flex; flex-direction: column;">
      <mat-form-field appearance="fill">

        <mat-select
          placeholder="Select test to multiply limit values with."
          formControlName="LimitMultiplierTestId"

          >
          <mat-option [value]="null">No test selected</mat-option>
          @for(test of allTests$ | async; track test){
            <mat-option

              [value]="test.TestId"
              >
              {{ test.Name }}

              <label style="color: darkgray;">
                [{{ test.Abbreviation }}]

              </label>


            </mat-option>
          }
        </mat-select>
      </mat-form-field>


    </div>
<!-- 
    <mat-label>Advanced options</mat-label> -->
    <div style="display: flex; flex-direction: column;">
      <mat-slide-toggle
        color="primary"


        matInput
        formControlName="UseFormula"
        >
        Use formula to calculate limits
      </mat-slide-toggle>


      <div style="display: flex;  flex-direction:row;">
        <mat-form-field appearance="fill" style="width: 450px;">
          <mat-label>Formula</mat-label>
          <!--  <textarea
          matInput

          formControlName="Formula"
          (input)="onInput($event)"
          [matAutocomplete]="auto"
          [matAutocompleteDisabled]="!shouldShowAutocomplete"
          (focus)="onFocus()"
          (optionSelected)="onOptionSelected($event)"
          placeholder="Type [ to open list of tests"

        >              </textarea> -->
        <textarea
          matInput
          (input)="onInput($event)"

          formControlName="Formula"


        >              </textarea>
        @if(formTest.get('UseFormula').value &&!this.FormulaErrors!==null && this.formulaIsValidated() == true && !this.isFormulaChangedSinceLastVerify() && this.formTest.get('Formula').value.trim()!==''){
          <mat-hint align="start" style="color: greenyellow">Formula is valid</mat-hint>
          }@else if(formTest.get('UseFormula').value){
          <mat-hint align="start" style="color: rgb(255, 81, 81)">Please verify formula</mat-hint>
        }
        <!--                 <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="onOptionSelected($event)">
        @for(option of allTests$ | async; track index){
          <mat-option [value]="option.Abbrevation">
            {{ option.Name }}
          </mat-option>
        }
      </mat-autocomplete> -->

    </mat-form-field>
    <button mat-button type="button" (click)="verifyFormula()" color="primary" [disabled]="!formTest.get('UseFormula').value || formulaIsValidated() && !isFormulaChangedSinceLastVerify() && this.formTest.get('Formula').value.trim()!==''">
      <mat-icon>check</mat-icon> VERIFY
    </button>
  </div>
  @if(this.formTest.controls['UseFormula'].value){
    <!-- <mat-label >IsOriginal:{{this.originalFormula==this.formTest.controls['Formula'].value}} Verified:{{this.formulaIsValidated() && !this.isFormulaChangedSinceLastVerify()}}</mat-label> -->
    @if(this.FormulaErrors!==null){

      @for(error of this.FormulaErrors; track index){
        <div style="color: rgb(255, 81, 81);">
          {{error}}
        </div>
      }

    }

  }
    
  </div>
}
  <br/>

</form>
}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="save()" color="primary" [disabled]="!formTest.valid || !this.formulaIsValidated() || this.isFormulaChangedSinceLastVerify() || (this.formTest.get('Formula').value.trim()==='' && this.formTest.get('UseFormula').value)">SAVE</button>
  <button mat-button mat-dialog-close>CANCEL</button>

</mat-dialog-actions>
